import { useBreakpoints } from '@vueuse/core'

const regexUser = new RegExp('/account*')
const arr = [
    regexUser,
    new RegExp('/ca-cuoc-the-thao'),
    new RegExp('/casino*'),
    new RegExp('/games*'),
    new RegExp('/ksports*'),
    new RegExp('/saba-sports'),
    new RegExp('/btisports'),
    new RegExp('/im-sports'),
    new RegExp('/virtual-ksports'),
    new RegExp('/in-play'),
    new RegExp('/virtual-saba-sports'),
    new RegExp('/virtual-pp-sports'),
]

export const useCommon = () => {
    const route = useRoute()
    const router = useRouter()
    const breakpoints = useBreakpoints({
        mobile: 0,
        pc: 1200,
    })

    const { isSafari, isMobileOrTablet } = useDevice()
    const rawHeaders = useNuxtApp().ssrContext?.event?.node?.req?.rawHeaders
    const userAgentIndex = rawHeaders?.indexOf('user-agent') || 0

    const initValueBaseOnUserAgent = () => {
        if (userAgentIndex !== -1 && rawHeaders?.[userAgentIndex + 1]) {
            const userAgent = rawHeaders[userAgentIndex + 1]
            return /mobile/i.test(userAgent)
        }
        return isMobileOrTablet
    }

    const isMobile = ref(initValueBaseOnUserAgent())

    watch(
        () => breakpoints.greaterOrEqual('pc').value,
        (newVal) => {
            if (import.meta.client) {
                isMobile.value = !newVal
            }
        },
        {
            immediate: true,
        }
    )

    const openNewTab = async (
        url: string,
        callback: () => Promise<string | null> = async () => null,
        isHtmlDocument = false,
        isDesktopNewTab = true
    ) => {
        if (!isDesktopNewTab && !isMobile.value) {
            return
        }
        let newTab = isSafari ? window.open('about:blank', '_blank') : null
        const newUrl = await callback()
        if (newUrl) {
            url = newUrl
        }
        if (url) {
            if (newTab) {
                setTimeout(() => {
                    if (isHtmlDocument) {
                        newTab.document.open()
                        newTab.document.write(url)
                        newTab.document.close()
                    } else {
                        newTab.location.href = url
                    }
                })
            } else {
                if (isHtmlDocument) {
                    const newTab = window.open('about:blank', '_blank')
                    newTab?.document.open()
                    newTab?.document.write(url)
                    newTab?.document.close()
                } else {
                    window.open(url, '_blank')
                }
            }
        } else {
            newTab?.close()
        }
    }

    const goBackHistory = (defautl = '/') => {
        const historyState = router.options.history.state
        if (historyState?.replaced) {
            router.push(defautl)
        } else {
            router.back()
        }
    }

    const delay = (ms = 300) =>
        new Promise<void>((resolve) => {
            const startTime = Date.now()
            while (Date.now() - startTime < ms) {
                /* empty */
            }
            resolve()
        })

    const isShowShortenFooter = computed(() =>
        arr.some((i) => i.test(route.path))
    )

    return {
        isMobile,
        openNewTab,
        goBackHistory,
        delay,
        isShowShortenFooter,
    }
}
